// AIDEV-NOTE: Barra de filtros para relatorios — periodo (ultimos 6 meses) + botao Aplicar
import { useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Button } from '@mui/material';
import type { ReportFilter } from '@azoupvendas/shared';

interface FilterBarProps {
  filter: ReportFilter;
  onChange: (f: ReportFilter) => void;
  showVendedorFilter?: boolean;
}

function getLast6Months(): string[] {
  const months: string[] = [];
  const now = new Date();
  for (let i = 0; i < 6; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    months.push(`${yyyy}-${mm}`);
  }
  return months;
}

function formatPeriodo(periodo: string): string {
  const parts = periodo.split('-');
  const year = parts[0] ?? '';
  const month = parts[1] ?? '01';
  const meses = [
    'Janeiro',
    'Fevereiro',
    'Marco',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ] as const;
  const idx = parseInt(month, 10) - 1;
  return `${meses[idx] ?? 'Janeiro'} ${year}`;
}

export function FilterBar({
  filter,
  onChange,
  showVendedorFilter: _showVendedorFilter
}: FilterBarProps) {
  const months = getLast6Months();
  const [selectedPeriodo, setSelectedPeriodo] = useState<string>(filter.periodo ?? months[0] ?? '');

  const handleAplicar = () => {
    onChange({ ...filter, periodo: selectedPeriodo });
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="periodo-label">Periodo</InputLabel>
        <Select
          labelId="periodo-label"
          label="Periodo"
          value={selectedPeriodo}
          onChange={(e) => setSelectedPeriodo(e.target.value)}
        >
          {months.map((m) => (
            <MenuItem key={m} value={m}>
              {formatPeriodo(m)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button variant="contained" onClick={handleAplicar}>
        Aplicar
      </Button>
    </Box>
  );
}
